import React, { useCallback, useEffect, useRef } from 'react';
import './EmailAutoCompleteListBox.css';
import { useAutoFillFocus } from '../../../../PqDataEntryForm/providers/AutoFillFocusProvider';

interface IEmailAutoCompleteListBoxProps {
    filteredEmailsSuffixes: string[];
    currentIndex?: number;
    setCurrentIndex: React.Dispatch<React.SetStateAction<number | undefined>>;
    setValue(newValue: string): void;
    currentValue: string;
    className?: string;
}

export default function EmailAutoCompleteListBox({
    filteredEmailsSuffixes,
    currentIndex,
    setCurrentIndex,
    setValue,
    currentValue,
    className = '',
}: IEmailAutoCompleteListBoxProps) {
    const {
        setFocusedToFalse,
        setMouseIsWithinListboxToTrue,
        setMouseIsWithinListboxToFalse,
    } = useAutoFillFocus();
    const listbox = useRef<HTMLDivElement>(null);

    const mousEnterHandler = useCallback(() => {
        setMouseIsWithinListboxToTrue();
    }, []);

    const mouseLeaveHandler = useCallback(() => {
        setMouseIsWithinListboxToFalse();
    }, []);

    useEffect(() => {
        if (currentIndex) {
            if (currentIndex > filteredEmailsSuffixes.length - 1) {
                setCurrentIndex(filteredEmailsSuffixes.length - 1);
            }
        }
    }, [filteredEmailsSuffixes]);

    return (
        <div
            ref={listbox}
            className={`EmailAutoCompleteListBox EmailAutoCompleteListBox__${className}`}
            onMouseEnter={mousEnterHandler}
            onMouseLeave={mouseLeaveHandler}
        >
            {filteredEmailsSuffixes.map((suffix, index) => {
                const choice =
            currentValue.slice(
                0,
                currentValue.indexOf('@'),
            ) + suffix;
                let dataChosen = false;
                if (currentIndex !== undefined) {
                    dataChosen = index === currentIndex;
                }
                return (
                    <div
                        className='EmailAutoCompleteListBox__listOption'
                        onMouseDown={() => {
                            setValue(choice);
                        }}
                        onClick={() => {
                            setFocusedToFalse();
                        }}
                        key={index}
                        data-chosen={dataChosen}
                        aria-label={choice}
                    >
                        <div className='EmailAutoCompleteListBox__optionContainer'>
                            {choice}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
